export const CORES_SITUACAO_AGENDAMENTO = [
  '#84b6f4',
  '#77dd77',
  '#FFA500',
  '#ff6961',
  '#c5c6c8',
  '#FFD700',
];
